import React from "react";
import { SRLWrapper } from "simple-react-lightbox"; // Import SRLWrapper
import livaT from "../../assets/img/gallery/thumbnail/liva-sm.jpg"
import liva from "../../assets/img/gallery/liva-sm.jpg"
import lodaT from "../../assets/img/gallery/thumbnail/loda-sm.jpg"
import loda from "../../assets/img/gallery/loda-sm.jpg"
import maidanT from "../../assets/img/gallery/thumbnail/maidan-sm.jpg"
import maidan from "../../assets/img/gallery/maidan-sm.jpg"
import mannaT from "../../assets/img/gallery/thumbnail/manna-sm.jpg"
import manna from "../../assets/img/gallery/manna-sm.jpg"
import arcadiumT from "../../assets/img/gallery/thumbnail/arcadium-sm.jpg"
import arcadium from "../../assets/img/gallery/arcadium-sm.jpg"
import cetmenT from "../../assets/img/gallery/thumbnail/cetmen-sm.jpg"
import cetmen from "../../assets/img/gallery/cetmen-sm.jpg"
import gs1T from "../../assets/img/gallery/thumbnail/gs1-sm.jpg"
import gs1 from "../../assets/img/gallery/gs1-sm.jpg"
import hacibabakahveciT from "../../assets/img/gallery/thumbnail/hacibaba-sm.jpg"
import hacibabakahveci from "../../assets/img/gallery/hacibaba-sm.jpg"
import hacibabaT from "../../assets/img/gallery/thumbnail/hacibaba-kuruyemis-sm.jpg"
import hacibaba from "../../assets/img/gallery/hacibaba-kuruyemis-sm.jpg"
import idasT from "../../assets/img/gallery/thumbnail/idas-sm.jpg"
import idas from "../../assets/img/gallery/idas-sm.jpg"
import istikbalT from "../../assets/img/gallery/thumbnail/istikbal-sm.jpg"
import istikbal from "../../assets/img/gallery/istikbal-sm.jpg"
import kentparkT from "../../assets/img/gallery/thumbnail/kentpark-sm.jpg"
import kentpark from "../../assets/img/gallery/kentpark-sm.jpg"
import kipaT from "../../assets/img/gallery/thumbnail/kipa-sm.jpg"
import kipa from "../../assets/img/gallery/kipa-sm.jpg"
import konforT from "../../assets/img/gallery/thumbnail/konfor-sm.jpg"
import konfor from "../../assets/img/gallery/konfor-sm.jpg"
import kuhneT from "../../assets/img/gallery/thumbnail/kuhne-sm.jpg"
import kuhne from "../../assets/img/gallery/kuhne-sm.jpg"

import smmatbuu from "../../assets/img/gallery/matbuu-sm.jpg"
import smonetower from "../../assets/img/gallery/onetower-sm.jpg"
import smpakmayaMy from "../../assets/img/gallery/pakmaya-my-sm.jpg"
import smpakmayaPpd from "../../assets/img/gallery/pakmaya-ppd-sm.jpg"
import smpakmaya from "../../assets/img/gallery/pakmaya-sm.jpg"
import smmatbuuT from "../../assets/img/gallery/thumbnail/matbuu-sm.jpg"
import smonetowerT from "../../assets/img/gallery/thumbnail/onetower-sm.jpg"
import smpakmayaMyT from "../../assets/img/gallery/thumbnail/pakmaya-my-sm.jpg"
import smpakmayaPpdT from "../../assets/img/gallery/thumbnail/pakmaya-ppd-sm.jpg"
import smpakmayaT from "../../assets/img/gallery/thumbnail/pakmaya-sm.jpg"

import lovaT from "../../assets/img/gallery/lova-sm.jpg"
import lova from "../../assets/img/gallery/lova-sm-detail.jpg"
import nextlevelT from "../../assets/img/gallery/nextlevel-sm.jpg"
import nextlevel from "../../assets/img/gallery/nextlevel-sm-detail.jpg"
import tanotoT from "../../assets/img/gallery/tanoto-sm.jpg"
import tanoto from "../../assets/img/gallery/tanoto-sm-detail.jpg"
import nillsT from "../../assets/img/gallery/nills-sm.jpg"
import nills from "../../assets/img/gallery/nills-sm-detail.jpg"
import smartT from "../../assets/img/gallery/smart-sm.jpg"
import smart from "../../assets/img/gallery/smart-sm-detail.jpg"
import weltewT from "../../assets/img/gallery/weltew-sm.jpg"
import weltew from "../../assets/img/gallery/weltew-sm-detail.jpg"


const List = () => {
  const imgs = [
    {
      thumb: lovaT,
      img: lova,
      head: 'Lova Yatak',
      alt: 'Lova Yatak Sosyal Medya Yönetimi',
    },
    {
      thumb: nextlevelT,
      img: nextlevel,
      head: 'Next Level',
      alt: 'Next Level Sosyal Medya Yönetimi',
    },
    {
      thumb: tanotoT,
      img: tanoto,
      head: 'Tanoto',
      alt: 'Tanoto Sosyal Medya Yönetimi',
    },
    {
      thumb: nillsT,
      img: nills,
      head: "Nill's",
      alt: "Nill's Sosyal Medya Yönetimi",
    },
    {
      thumb: smartT,
      img: smart,
      head: 'Smart Energy',
      alt: 'Smart Energy Sosyal Medya Yönetimi',
    },
    {
      thumb: weltewT,
      img: weltew,
      head: 'Weltew Home',
      alt: 'Weltew Home Sosyal Medya Yönetimi',
    },
    {
      thumb: smmatbuuT,
      img: smmatbuu,
      head: 'Matbuu',
      alt: 'Matbuu Sosyal Medya Yönetimi',
    },
    {
      thumb: smonetowerT,
      img: smonetower,
      head: 'One Tower',
      alt: 'One Tower Sosyal Medya Yönetimi',
    },
    {
      thumb: smpakmayaT,
      img: smpakmaya,
      head: 'Pakmaya',
      alt: 'Pakmaya Sosyal Medya Yönetimi',
    },
    {
      thumb: smpakmayaMyT,
      img: smpakmayaMy,
      head: 'Pakmaya Mutfağın Yıldızı',
      alt: 'Pakmaya Mutfağın Yıldızı Sosyal Medya Yönetimi',
    },
    {
      thumb: smpakmayaPpdT,
      img: smpakmayaPpd,
      head: 'Pakmaya Profesyoneller Dünyası',
      alt: 'Pakmaya Profesyoneller Dünyası Sosyal Medya Yönetimi',
    },
    {
      thumb: livaT,
      img: liva,
      head: 'Liva Pastacılık',
      alt: 'Liva Pastacılık Sosyal Medya Yönetimi',
    },
    {
      thumb: lodaT,
      img: loda,
      head: 'Loda',
      alt: 'Loda Sosyal Medya Yönetimi',
    },
    {
      thumb: maidanT,
      img: maidan,
      head: 'Maidan',
      alt: 'Maidan Sosyal Medya Yönetimi',
    },
    {
      thumb: mannaT,
      img: manna,
      head: 'Manna Hotel',
      alt: 'Manna Hotel Sosyal Medya Yönetimi',
    },
    {
      thumb: arcadiumT,
      img: arcadium,
      head: 'Arcadium AVM',
      alt: 'Arcadium AVM Sosyal Medya Yönetimi',
    },
    {
      thumb: cetmenT,
      img: cetmen,
      head: 'Çetmen',
      alt: 'Çetmen Sosyal Medya Yönetimi',
    },
    {
      thumb: gs1T,
      img: gs1,
      head: 'GS1',
      alt: 'GS1 Sosyal Medya Yönetimi',
    },
    {
      thumb: hacibabakahveciT,
      img: hacibabakahveci,
      head: 'Kahveci Hacıbaba',
      alt: 'Kahveci Hacıbaba Sosyal Medya Yönetimi',
    },
    {
      thumb: hacibabaT,
      img: hacibaba,
      head: 'Hacıbaba Kuruyemiş',
      alt: 'Hacıbaba Kuruyemiş Sosyal Medya Yönetimi',
    },
    {
      thumb: idasT,
      img: idas,
      head: 'İdaş',
      alt: 'İdaş Sosyal Medya Yönetimi',
    },
    {
      thumb: istikbalT,
      img: istikbal,
      head: 'İstikbal Mobilya',
      alt: 'İstikbal Mobilya Sosyal Medya Yönetimi',
    },
    {
      thumb: kentparkT,
      img: kentpark,
      head: 'Kentpark AVM',
      alt: 'Kentpark AVM Sosyal Medya Yönetimi',
    },
    {
      thumb: kipaT,
      img: kipa,
      head: 'Kipa AVM',
      alt: 'Kipa AVM Sosyal Medya Yönetimi',
    },
    {
      thumb: konforT,
      img: konfor,
      head: 'Konfor',
      alt: 'Konfor Sosyal Medya Yönetimi',
    },
    {
      thumb: kuhneT,
      img: kuhne,
      head: 'Kuhne',
      alt: 'Kuhne Sosyal Medya Yönetimi',
    },
  ]

  return (
    imgs.map((item, i) => {
      return (
        <div key={i} className="image">
          <div className="hover">
            <a href={item.img} className="thumb" data-attribute="SRL">
              <img alt={item.alt} src={item.thumb} />
            </a>
          </div>
          <p className="img-head">{item.head}</p>
          <p>{item.alt}</p>
        </div>
      )
    })
  );
}


function SocialGallery() {
  return (
    <SRLWrapper>
      <div className="gallery container">

        <List />

      </div>
    </SRLWrapper>
  );
}

export default SocialGallery;